import React from 'react';
import moment from 'moment';
import Chart from './chart'
import 'frappe-charts/dist/frappe-charts.min.css'

export default function OrderGrid({ order_data, active_selection, hide_symbol_column, onPositonSelected }) {


    return (
        <table className="table table is-narrow is-fullwidth table is-hoverable">
            <thead>
                <th>Date</th>
                <th><span className="is-pulled-left">Side</span></th>
                {(!hide_symbol_column) && <th>Symbol</th>}

                <th><span className="is-pulled-right">Price</span></th>
                <th><span className="is-pulled-right">Quantity</span></th>
                <th><span className="is-pulled-right">Total Amount</span></th>
            </thead>
            <tbody>
                {order_data && order_data.map(function (order_item, i) {

                    if(!order_item){
                        return;
                    }
                    var is_sell = order_item.side === 'sell';
                    var total_invested = order_item.quantity * order_item.average_price;
                    return <tr>
                        <td>{moment(order_item.date).format("LL")}</td>
                        <td><span className={"tag " + (is_sell ? "is-success" : "is-danger")}>{order_item.side}</span></td>
                        {(!hide_symbol_column) && <td>{order_item.symbol}</td>}
                        <td><span className="is-pulled-right ">{order_item.average_price.toFixed(2)}</span></td>
                        <td><span className="is-pulled-right">{is_sell ? "-" : "+"}{order_item.quantity}</span></td>
                        <td><span className={"is-pulled-right " + (is_sell ? "has-text-success" : "has-text-danger")}>{is_sell ? "+" : "-"}${total_invested.toFixed(2)}</span></td>
                    </tr>
                })}
            </tbody>

        </table>
    );
}


// WEBPACK FOOTER //
// ./src/components/order-grid.js